import { render, staticRenderFns } from "./Tccl1.vue?vue&type=template&id=194bb01c&scoped=true&"
import script from "./Tccl1.vue?vue&type=script&lang=js&"
export * from "./Tccl1.vue?vue&type=script&lang=js&"
import style0 from "./Tccl1.vue?vue&type=style&index=0&id=194bb01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194bb01c",
  null
  
)

export default component.exports